export default {
  ContextVisualizer__ARIA_LABEL: "Select to close",
};
